import {z} from "zod"
import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {box2Like} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"
import {imageOpHalOptions} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal-types"

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            imageOpHalOptions: imageOpHalOptions,

            sourceImage: anyImageOpResult,
            mipLevelOffset: z.number(),
            region: box2Like,
        }),
    },
}
